import $ from 'jquery';
import Youtube from './youtube';
import * as events from './events';
import defaultConfigs from './default-configs';

export default $.extend(Youtube, {
  events,
  create(containerId, configs) {
    return new Youtube(containerId, $.extend({}, defaultConfigs, configs));
  }
});


/** WEBPACK FOOTER **
 ** ./src/VO2/libs/core/youtube-player/index.js
 **/